import React, { useState, useEffect } from 'react';
import { privateAPI } from '../util/api';
import { useNavigate } from 'react-router-dom';

const Dashboard = () => {
  const [webhooks, setWebhooks] = useState([]);
  const [copied, setCopied] = useState(null);
  const navigate = useNavigate();

  const serverAddress = process.env.REACT_APP_SERVER_ADDRESS;

  useEffect(() => {
    const fetchWebhooks = async () => {
      try {
        const response = await privateAPI.get('/webhooks');
        const sortedWebhooks = response.data.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
        setWebhooks(sortedWebhooks);
      } catch (error) {
        // Логирование ошибки, если требуется
        console.error('Failed to fetch webhooks:', error);
      }
    };

    fetchWebhooks();
  }, []);

  const copyToClipboard = (webhookUrl, webhookId) => {
    navigator.clipboard.writeText(webhookUrl)
      .then(() => {
        setCopied(webhookId);
        setTimeout(() => setCopied(null), 3000);
      })
      .catch(err => {
        console.error('Failed to copy: ', err);
      });
  };

  return (
    <div className="container mx-auto px-4 py-6 max-w-screen-lg">
      <div className="flex justify-end mb-4">
        <button
          onClick={() => navigate('/create-webhook')}
          className="bg-indigo-600 text-white px-4 py-2 rounded-md hover:bg-indigo-500"
        >
          Create Webhook
        </button>
      </div>

      <div className="relative overflow-x-auto max-w-screen-lg mx-auto">
        <table className="w-full text-sm text-left text-gray-700">
          <thead className="text-xs text-gray-700 uppercase bg-gray-100">
            <tr>
              <th scope="col" className="px-6 py-3">Webhook Name</th>
              <th scope="col" className="px-6 py-3">Service</th>
              <th scope="col" className="px-6 py-3 text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            {webhooks.length > 0 ? (
              webhooks.map((webhook) => {
                const webhookUrl = `${serverAddress}/${webhook.service}/${webhook._id}`;

                return (
                  <tr key={webhook._id} className="bg-white border-b">
                    <th
                      scope="row"
                      className="px-6 py-4 font-medium text-blue-600 cursor-pointer hover:text-blue-800"
                      onClick={() => navigate(`/edit-webhook/${webhook._id}`)}
                    >
                      {webhook.name}
                    </th>
                    <td className="px-6 py-4">
                      {webhook.service.charAt(0).toUpperCase() + webhook.service.slice(1)}
                    </td>
                    <td className="px-6 py-4 text-center">
                      <div className="flex justify-center gap-2">
                        <button
                          onClick={() => copyToClipboard(webhookUrl, webhook._id)}
                          className="bg-blue-500 text-white w-24 px-2 py-1 rounded-md hover:bg-blue-400 text-sm"
                        >
                          Copy URL
                        </button>
                        <button
                          onClick={() => navigate(`/logs/${webhook._id}`)}
                          className="bg-gray-500 text-white w-20 px-2 py-1 rounded-md hover:bg-gray-400 text-sm"
                        >
                          Logs
                        </button>
                        <button
                          onClick={() => navigate(`/edit-webhook/${webhook._id}`)}
                          className="bg-yellow-500 text-white w-20 px-2 py-1 rounded-md hover:bg-yellow-400 text-sm"
                        >
                          Edit
                        </button>
                      </div>
                      {copied === webhook._id && (
                        <span className="text-green-500 mt-2 block">Webhook URL copied!</span>
                      )}
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="3" className="px-6 py-4 text-center text-gray-500">
                  No webhooks available.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Dashboard;